import { createSlice, nanoid } from "@reduxjs/toolkit";

const DEFAULT_DURATION_MS = 5200;
const MAX_TOASTS = 6;

/**
 * @typedef {'success' | 'error' | 'info'} ToastVariant
 */

const initialState = {
  /** @type {{ id: string, variant: ToastVariant, title: string, message?: string, durationMs?: number }[]} */
  items: [],
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    pushToast: {
      reducer(state, action) {
        state.items.push(action.payload);
        if (state.items.length > MAX_TOASTS) {
          state.items.splice(0, state.items.length - MAX_TOASTS);
        }
      },
      prepare({ variant = "info", title, message, durationMs }) {
        return {
          payload: {
            id: nanoid(),
            variant,
            title: title || "",
            message: message || "",
            durationMs: durationMs ?? DEFAULT_DURATION_MS,
          },
        };
      },
    },
    dismissToast(state, action) {
      const id = action.payload;
      state.items = state.items.filter((t) => t.id !== id);
    },
    clearToasts(state) {
      state.items = [];
    },
  },
});

export const { pushToast, dismissToast, clearToasts } = toastSlice.actions;
export default toastSlice.reducer;
